import React from 'react';
import { EpisodeCard } from './EpisodeCard';
const episodes = [{
  number: '01',
  title: 'The Pivot',
  description: 'When the initial vision fails, the true test of a founder begins. An intimate look at the 48 hours that saved a billion-dollar company.',
  image: 'https://images.unsplash.com/photo-1517059224940-d4af9eec41b7?q=80&w=1600&auto=format&fit=crop',
  duration: '42:15',
  year: '2012'
}, {
  number: '02',
  title: 'First Dollar',
  description: 'Before the IPOs and the headlines, there was the first sale. Three founders recount the gritty, unglamorous reality of earning their first dollar.',
  image: 'https://images.unsplash.com/photo-1559056961-1f4dbbf9d36a?q=80&w=1600&auto=format&fit=crop',
  duration: '38:50',
  year: '2015'
}, {
  number: '03',
  title: 'The Long Night',
  description: 'Burnout, betrayal, and the psychological toll of hyper-growth. A raw examination of the mental health crisis silently sweeping Silicon Valley.',
  image: 'https://images.unsplash.com/photo-1454496522488-7a8e488e8606?q=80&w=1600&auto=format&fit=crop',
  duration: '55:20',
  year: '2018'
}, {
  number: '04',
  title: 'Legacy Code',
  description: 'What happens when the founder leaves? The complex transition of power and the struggle to maintain a soul in a corporate machine.',
  image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=1600&auto=format&fit=crop',
  duration: '47:10',
  year: '2021'
}];
export function FeaturedEpisodes() {
  return <section className="py-24 px-6 md:px-12 bg-archival-cream relative" data-id="element-36">
      {/* Background Pattern Accent */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-pattern-geometric opacity-20 pointer-events-none" data-id="element-37" />

      <div className="max-w-7xl mx-auto" data-id="element-38">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 border-b-4 border-gold pb-8 relative" data-id="element-39">
          {/* Decorative Pattern Line */}
          <div className="absolute bottom-[-4px] left-0 w-1/3 h-1 bg-earth-terracotta z-10" data-id="element-40" />

          <div data-id="element-41">
            <span className="font-mono text-earth-terracotta text-sm tracking-widest uppercase mb-3 block font-bold" data-id="element-42">
              Featured Collection
            </span>
            <h2 className="text-4xl md:text-6xl font-sans font-black text-charcoal-900" data-id="element-43">
              SELECTED{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-earth-ochre" data-id="element-44">
                CHAPTERS
              </span>
            </h2>
          </div>
          <div className="mt-6 md:mt-0 font-mono text-charcoal-500 text-sm text-right" data-id="element-45">
            <p className="font-bold text-charcoal-900" data-id="element-46">TOTAL RUNTIME: 3H 03M</p>
            <p data-id="element-47">4 REELS AVAILABLE</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-48">
          {episodes.map((episode, index) => <div key={episode.number} className="group relative" data-id="element-49">
              {/* Card Background with Pattern */}
              <div className="absolute -inset-2 bg-gradient-to-r from-gold/20 to-earth-terracotta/20 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-sm" data-id="element-50" />

              <div className="relative bg-white border border-charcoal-200 p-6 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-51">
                {/* Image Container */}
                <div className="aspect-video overflow-hidden mb-6 relative border-b-4 border-gold" data-id="element-52">
                  <img src={episode.image} alt={episode.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" data-id="element-53" />
                  <div className="absolute top-4 left-4 bg-charcoal-900 text-gold font-mono text-xs px-2 py-1 uppercase tracking-widest" data-id="element-54">
                    Ep. {episode.number}
                  </div>
                  <div className="absolute bottom-0 right-0 bg-gold text-charcoal-900 font-mono text-xs px-3 py-1 font-bold" data-id="element-55">
                    {episode.duration}
                  </div>
                </div>

                {/* Content */}
                <div className="flex justify-between items-baseline mb-3" data-id="element-56">
                  <span className="font-mono text-earth-terracotta text-sm font-bold" data-id="element-57">
                    {episode.year}
                  </span>
                </div>

                <h3 className="text-2xl font-serif font-bold text-charcoal-900 mb-3 group-hover:text-earth-terracotta transition-colors" data-id="element-58">
                  {episode.title}
                </h3>

                <p className="text-charcoal-600 font-serif leading-relaxed mb-6" data-id="element-59">
                  {episode.description}
                </p>

                <div className="flex items-center text-sm font-sans font-bold text-charcoal-900 uppercase tracking-wider group-hover:text-gold transition-colors" data-id="element-60">
                  Listen Now <span className="ml-2" data-id="element-61">→</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}